import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import NavbarTag from "react-bootstrap/Navbar";
import "../Style/services.css";
import { CASE_STUDIES_BY_SLUG } from "./serviceCaseStudies";

const caseStudyEntries = Object.entries(CASE_STUDIES_BY_SLUG);

const Services = () => {
  return (
    <div className="main-section services-layout">
      <section>
        <NavbarTag expand="lg">
          <NavLink end to="/" className="listItem" activeclassname="activeItem">
            Home
          </NavLink>
          <NavLink to="/about" className="listItem" activeclassname="activeItem">
            About
          </NavLink>
          <NavLink to="/contact" className="listItem" activeclassname="activeItem">
            Contact
          </NavLink>
          <NavLink to="/products" className="listItem" activeclassname="activeItem">
            Products
          </NavLink>
          <NavLink to="/services" className="listItem" activeclassname="activeItem">
            Services
          </NavLink>
        </NavbarTag>
      </section>

      <div className="services-layout-body">
        <aside className="services-tree" aria-label="Services sections">
          <div className="services-tree-title">On this area</div>
          <ul className="services-tree-list">
            <li>
              <NavLink
                end
                to="/services"
                className={({ isActive }) =>
                  `services-tree-link${isActive ? " services-tree-link--active" : ""}`
                }
              >
                Overview
              </NavLink>
            </li>
            <li className="services-tree-branch">
              <span className="services-tree-label">Case studies</span>
              <ul className="services-tree-nested">
                {caseStudyEntries.map(([slug, meta]) => (
                  <li key={slug}>
                    <NavLink
                      to={`/services/case-studies/${slug}`}
                      className={({ isActive }) =>
                        `services-tree-link${isActive ? " services-tree-link--active" : ""}`
                      }
                    >
                      {meta.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </aside>

        <div className="services-outlet">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Services;
